const birthdayCards = {
  to: '/', label: 'Birthday Cards',
  dropdown: [
    {
      title: 'By Age',
      items: [
        { to: '/', label: '1st Birthday' },
        { to: '/', label: '16th Birthday' },
        { to: '/', label: '18th Birthday' },
        { to: '/', label: '21st Birthday' },
        { to: '/', label: '30th Birthday' },
        { to: '/', label: '40th Birthday' },
        { to: '/', label: '50th Birthday' },
        { to: '/', label: '60th Birthday' },
        { to: '/', label: '70th Birthday' },
        { to: '/', label: '80th Birthday' },
        { to: '/', label: '90th Birthday' },
        { to: '/', label: '100th Birthday' },
      ],
    },
    {
      title: 'For Her',
      items: [
        { to: '/', label: 'All Cards for Her', },
        { to: '/', label: 'Best Friend', },
        { to: '/', label: 'Daughter', },
        { to: '/', label: 'Grandma', },
        { to: '/', label: 'Mum', },
        { to: '/', label: 'Sister', },
        { to: '/', label: 'Wife', },
        { to: '/', label: 'Cute Cards', },
        { to: '/', label: 'Funny Cards', },
        { to: '/', label: 'Modern Cards', },
        { to: '/', label: 'Photo Upload Cards', },
        { to: '/', label: 'New Birthday Cards', },
      ],
    },
    {
      title: 'For Him',
      items: [
        { to: '/', label: 'All Cards for Him' },
        { to: '/', label: 'Boyfriend' },
        { to: '/', label: 'Brother' },
        { to: '/', label: 'Dad' },
        { to: '/', label: 'Grandad' },
        { to: '/', label: 'Husband' },
        { to: '/', label: 'Son' },
        { to: '/', label: 'Funny Cards' },
        { to: '/', label: 'Photo Upload Cards' },
        { to: '/', label: 'New Birthday Cards' },
      ]
    },
    {
      title: 'For Kids',
      items: [
        { to: '/', label: 'All Cards for Kids' },
        { to: '/', label: 'Babies' },
        { to: '/', label: 'Boys' },
        { to: '/', label: 'Girls' },
        { to: '/', label: 'Disney' },
        { to: '/', label: 'Peppa Pig' },
        { to: '/', label: 'Activity Cards' },
        { to: '/', label: 'Birthday Party Invitations' },
        { to: '/', label: 'New Birthday Cards' },
      ]
    },
    {
      title: 'Designs & themes',
      items: [
        { to: '/', label: 'Animals' },
        { to: '/', label: 'Arty' },
        { to: '/', label: 'Cats' },
        { to: '/', label: 'Concertina/4-Fold' },
        { to: '/', label: 'Cute' },
        { to: '/', label: 'Dogs' },
        { to: '/', label: 'Funny' },
        { to: '/', label: 'Football' },
        { to: '/', label: 'Groovy Chick' },
        { to: '/', label: 'Marvel' },
        { to: '/', label: 'Me to You' },
        { to: '/', label: 'Movies & TV' },
        { to: '/', label: 'Non-Personalised Cards' },
        { to: '/', label: 'Photo Upload' },
        { to: '/', label: 'Traditional' },
        { to: '/', label: 'Winnie the Pooh' },
      ]
    }
  ]
}

const cards = {
  to: '/', label: 'Cards',
  dropdown: [
    {
      title: 'Mother\'s Day',
      items: [
        { to: '/', label: 'All Mother\'s Day Cards' },
        { to: '/', label: 'For Mum' },
        { to: '/', label: 'For Grandma' },
        { to: '/', label: 'Photo Cards' },
        { to: '/', label: 'Non Photo Cards' },
        { to: '/', label: 'Giant Cards' },
        { to: '/', label: 'Large Cards' },
        { to: '/', label: 'Funny Cards' },
        { to: '/', label: 'Cute Cards' },
        { to: '/', label: 'Traditional Cards' },
        { to: '/', label: 'Animal Cards' },
        { to: '/', label: 'Floral Cards' },
      ]
    },
    {
      title: 'Anniversary',
      items: [
        { to: '/', label: 'All Anniversary Cards' },
        { to: '/', label: 'Girlfriend' },
        { to: '/', label: 'Boyfriend' },
        { to: '/', label: 'Husband' },
        { to: '/', label: 'Wife' },
        { to: '/', label: 'Parents' },
        { to: '/', label: 'Couples' },
        { to: '/', label: 'Grandparents' },
      ]
    },
    {
      title: 'Weddings & Engagement',
      items: [
        { to: '/', label: 'All Wedding Cards' },
        { to: '/', label: 'All Engagement Cards' },
        { to: '/', label: 'Bridesmaids Cards' },
        { to: '/', label: 'Wedding Invitations' },
        { to: '/', label: 'Wedding Thank You' },
      ]
    },
    {
      title: 'Congratulations/Good Luck',
      items: [
        { to: '/', label: 'All Congratulations Cards' },
        { to: '/', label: 'Driving Test' },
        { to: '/', label: 'Exams' },
        { to: '/', label: 'Graduation' },
        { to: '/', label: 'New Baby' },
        { to: '/', label: 'New Home' },
        { to: '/', label: 'New Job' },
      ]
    },
    {
      title: 'Other Occasions',
      items: [
        { to: '/', label: 'Mother\'s Day' },
        { to: '/', label: 'Christening & Invites' },
        { to: '/', label: 'Christmas' },
        { to: '/', label: 'Easter' },
        { to: '/', label: 'Eid' },
        { to: '/', label: 'Father\'s Day' },
        { to: '/', label: 'Get Well' },
        { to: '/', label: 'Leaving' },
        { to: '/', label: 'Letters from Santa' },
        { to: '/', label: 'Sorry' },
        { to: '/', label: 'Sympathy' },
        { to: '/', label: 'Thank You' },
        { to: '/', label: 'Thinking of You' },
        { to: '/', label: 'Valentine\'s Day' },
      ]
    }
  ]
}

const foodAndDrink = {
  to: '/',
  label: 'Food & Drink',
  dropdown: [
    {
      title: 'Food',
      items: [
        { to: '/', label: 'All Food' },
        { to: '/', label: 'For Him' },
        { to: '/', label: 'For Her' },
        { to: '/', label: 'Cakes & Biscuits' },
        { to: '/', label: 'Chocolate' },
        { to: '/', label: 'Fudge & Caramels' },
        { to: '/', label: 'Hampers - From £25' },
        { to: '/', label: 'Jam & Preserves' },
        { to: '/', label: 'Sweets' },
        { to: '/', label: 'Make Your Own' },
      ]
    },
    {
      title: 'Drink',
      items: [
        { to: '/', label: 'All Drinks' },
        { to: '/', label: 'For Him' },
        { to: '/', label: 'For Her' },
        { to: '/', label: 'Beer' },
        { to: '/', label: 'Champagne' },
        { to: '/', label: 'Chocolate, Tea & Coffee' },
        { to: '/', label: 'Gin' },
        { to: '/', label: 'Letterbox Wine' },
        { to: '/', label: 'Personalised Alcohol Gifts' },
        { to: '/', label: 'Prosecco' },
        { to: '/', label: 'Spirits & Liqueurs' },
        { to: '/', label: 'Whisky' },
        { to: '/', label: 'Wine' },
      ]
    },
    {
      title: 'Occasions',
      items: [
        { to: '/', label: 'Anniversary' },
        { to: '/', label: 'Birthday' },
        { to: '/', label: 'Christmas' },
        { to: '/', label: 'Congratulations' },
        { to: '/', label: 'Engagement' },
        { to: '/', label: 'Get Well' },
        { to: '/', label: 'Good Luck' },
        { to: '/', label: 'New Baby' },
        { to: '/', label: 'Thank You' },
        { to: '/', label: 'Valentine\'s Day' },
        { to: '/', label: 'Wedding' },
      ]
    },
    {
      title: 'Brands',
      items: [
        { to: '/', label: 'Beer Hawk' },
        { to: '/', label: 'Cartwright & Butler' },
        { to: '/', label: 'Fudge Kitchen' },
        { to: '/', label: 'Hogs Back Brewery' },
        { to: '/', label: 'James Chocolates' },
        { to: '/', label: 'Lanson Champagne' },
        { to: '/', label: 'Lindt Chocolates' },
        { to: '/', label: 'Moët & Chandon Champagne' },
        { to: '/', label: 'Montezuma\'s' },
        { to: '/', label: 'Sipsmith' },
        { to: '/', label: 'Thorntons' },
      ]
    }
  ]
}

const gifts = {
  to: '/',
  label: 'Gifts',
  dropdown: [
    {
      title: 'Who\'s it For?',
      items: [
        { to: '/', label: 'For Him' },
        { to: '/', label: 'For Her' },
        { to: '/', label: 'For Babies' },
        { to: '/', label: 'For Kids' },
        { to: '/', label: 'For Teens' },
        { to: '/', label: 'For Adults' },
      ]
    },
    {
      title: 'Mother\'s Day',
      items: [
        { to: '/', label: 'All Personalised Gifts' },
        { to: '/', label: 'Gifts For Mum' },
        { to: '/', label: 'Hampers & Gift Sets' },
        { to: '/', label: 'Alcohol Gifts' },
        { to: '/', label: 'Beauty Gifts' },
        { to: '/', label: 'Soft Toys' },
        { to: '/', label: 'Food Gifts' },
        { to: '/', label: 'Chocolates' },
        { to: '/', label: 'Letterbox Gifts' },
        { to: '/', label: 'Novelty Gifts' },
      ]
    },
    {
      title: 'Personalised Gifts',
      items: [
        { to: '/', label: 'All Personalised Gifts' },
        { to: '/', label: 'Personalised Aprons' },
        { to: '/', label: 'Personalised Mugs' },
        { to: '/', label: 'Personalised Sacks' },
        { to: '/', label: 'Personalised Tote Bags' },
        { to: '/', label: 'Personalised T-Shirts' },
        { to: '/', label: 'Personalised Alcohol Gifts' },
      ]
    },
    {
      title: 'Gift Types',
      items: [
        { to: '/', label: 'Alcohol' },
        { to: '/', label: 'Balloons' },
        { to: '/', label: 'Beauty & Home' },
        { to: '/', label: 'Books' },
        { to: '/', label: 'Experience Days' },
        { to: '/', label: 'Gadgets & Novelties' },
        { to: '/', label: 'Gift Boxes' },
        { to: '/', label: 'Jewellery & Watches' },
        { to: '/', label: 'Letterbox Gifts' },
        { to: '/', label: 'Hampers' },
        { to: '/', label: 'Make Your Own' },
        { to: '/', label: 'Party Gifts Shop' },
        { to: '/', label: 'Soft Toys' },
        { to: '/', label: 'Stationery & Craft' },
        { to: '/', label: 'Special Offers' },
        { to: '/', label: 'Toys & Games' },
      ]
    },
    {
      title: 'Occasions',
      items: [
        { to: '/', label: 'Mother\'s Day' },
        { to: '/', label: 'Anniversary' },
        { to: '/', label: 'Birthday' },
        { to: '/', label: 'Christmas' },
        { to: '/', label: 'Congratulations' },
        { to: '/', label: 'Engagement' },
        { to: '/', label: 'Father\'s Day' },
        { to: '/', label: 'Get Well' },
        { to: '/', label: 'Good Luck' },
        { to: '/', label: 'Graduation' },
        { to: '/', label: 'New Baby' },
        { to: '/', label: 'Thank you' },
        { to: '/', label: 'Valentine\'s Day' },
        { to: '/', label: 'Wedding' },
      ]
    }
  ]
}

const flowersAndPlants = {
  to: '/',
  label: 'Flowers & Plants',
  dropdown: [
    {
      title: 'Flowers & Gifts',
      items: [
        { to: '/', label: 'All Flowers' },
        { to: '/', label: 'All Flowers & Plants' },
        { to: '/', label: 'All Plants' },
        { to: '/', label: 'Best Sellers' },
        { to: '/', label: 'Bouquet of the Month' },
        { to: '/', label: 'Flower & Plant Gift Sets' },
        { to: '/', label: 'Letterbox Flowers' },
        { to: '/', label: 'Luxury' },
        { to: '/', label: 'Plant of the Month' },
        { to: '/', label: 'Top Rated Flowers' },
      ]
    },
    {
      title: 'Flowers by Occasion',
      items: [
        { to: '/', label: 'Anniversary' },
        { to: '/', label: 'Birthday' },
        { to: '/', label: 'Congratulations' },
        { to: '/', label: 'Engagement' },
        { to: '/', label: 'Father\'s Day' },
        { to: '/', label: 'Get Well Soon' },
        { to: '/', label: 'Mother\'s Day' },
        { to: '/', label: 'New Baby' },
        { to: '/', label: 'New Home' },
        { to: '/', label: 'Retirement' },
        { to: '/', label: 'Sympathy' },
        { to: '/', label: 'Thank You' },
        { to: '/', label: 'Thinking of You' },
        { to: '/', label: 'Valentine\'s Day' },
      ]
    },
    {
      title: 'Flowers by Colour',
      items: [
        { to: '/', label: 'Bright Flowers' },
        { to: '/', label: 'Pink Flowers' },
        { to: '/', label: 'Rainbow Flowers' },
        { to: '/', label: 'Red Flowers' },
        { to: '/', label: 'White Flowers' },
        { to: '/', label: 'Mixed Flowers' },
      ]
    },
    {
      title: 'Price',
      items: [
        { to: '/', label: '£30 and Under' },
        { to: '/', label: '£31 - £40' },
        { to: '/', label: 'Over £40' },
      ]
    },
    {
      title: 'Mother\'s Day',
      items: [
        { to: '/', label: 'All Mother\'s Day Flowers' },
        { to: '/', label: 'Letterbox Flowers' },
        { to: '/', label: 'Flower Gift Sets' },
        { to: '/', label: 'Bright Flowers' },
        { to: '/', label: 'Pink Flowers' },
        { to: '/', label: 'Rainbow Flowers' },
        { to: '/', label: 'Red Flowers' },
        { to: '/', label: 'White Flowers' },
        { to: '/', label: 'Mixed Flowers' },
      ]
    }
  ]
}

const mothersDay = {
  to: '/',
  label: 'Mother\'s Day',
  dropdown: [
    {
      title: 'Who\'s the Card For?',
      items: [
        { to: '/', label: 'All Mother\'s Day Cards' },
        { to: '/', label: 'For Mum' },
        { to: '/', label: 'For Grandma / Nan' },
        { to: '/', label: 'From the Bump' },
        { to: '/', label: 'From the Kids' },
        { to: '/', label: '1st Mother\'s Day' },
        { to: '/', label: 'Like a Mum to me' },
        { to: '/', label: 'For Wife' },
        { to: '/', label: 'For Step Mum' },
        { to: '/', label: 'For Godmother' },
        { to: '/', label: 'From the Pet' },
      ]
    },
    {
      title: 'Cards',
      items: [
        { to: '/', label: 'All Mother\'s Day Cards' },
        { to: '/', label: 'Photo Upload Cards' },
        { to: '/', label: 'Non Photo Cards' },
        { to: '/', label: 'Giant Cards' },
        { to: '/', label: 'Large Cards' },
        { to: '/', label: 'Funny Cards' },
        { to: '/', label: 'Cute Cards' },
        { to: '/', label: 'Traditional Cards' },
        { to: '/', label: 'Animal Cards' },
        { to: '/', label: 'Floral Cards' },
        { to: '/', label: 'Disney Cards' },
        { to: '/', label: 'Tatty Teddy Cards' },
      ]
    },
    {
      title: 'Flowers',
      items: [
        { to: '/', label: 'All Mother\'s Day Flowers' },
        { to: '/', label: 'Bright Flowers' },
        { to: '/', label: 'Pink Flowers' },
        { to: '/', label: 'Rainbow Flowers' },
        { to: '/', label: 'Red Flowers' },
        { to: '/', label: 'White Flowers' },
        { to: '/', label: 'Mixed Flowers' },
        { to: '/', label: 'Flower Gift Sets' },
        { to: '/', label: 'Letterbox Flowers' },
      ]
    },
    {
      title: 'Gifts',
      items: [
        { to: '/', label: 'All Mother\'s Day Gifts' },
        { to: '/', label: 'For Mum' },
        { to: '/', label: 'For Grandma' },
        { to: '/', label: 'From the Bump' },
        { to: '/', label: 'Hampers & Gift Sets' },
        { to: '/', label: 'Alcohol Gifts' },
        { to: '/', label: 'Balloons' },
        { to: '/', label: 'Beauty Gifts' },
        { to: '/', label: 'Soft Toys' },
        { to: '/', label: 'Food Gifts' },
        { to: '/', label: 'Chocolates' },
        { to: '/', label: 'Letterbox Gifts' },
        { to: '/', label: 'Novelty Gifts' },
      ]
    },
    {
      title: 'Personalised Gifts',
      items: [
        { to: '/', label: 'All Personalised Gifts' },
        { to: '/', label: 'Personalised T-Shirts' },
        { to: '/', label: 'Personalised Mugs' },
        { to: '/', label: 'Personalised Alcohol Gifts' },
        { to: '/', label: 'Personalised Aprons' },
        { to: '/', label: 'Personalised Tote Bags' },
      ]
    }
  ]
}

export const navItems = [
  birthdayCards,
  cards,
  foodAndDrink,
  gifts,
  flowersAndPlants,
  mothersDay,
]
